"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
exports.__esModule = true;
exports.onStateChange = exports.onPluginLoad = exports.getPlugins = exports.getPlugin = exports.resetPlugins = exports.loadPlugins = exports.getPluginContext = exports.enablePlugin = exports.createPluginContext = exports.createPlugin = void 0;
var createPlugin_1 = require("./createPlugin");
__createBinding(exports, createPlugin_1, "createPlugin");
var createPluginContext_1 = require("./createPluginContext");
__createBinding(exports, createPluginContext_1, "createPluginContext");
var enablePlugin_1 = require("./enablePlugin");
__createBinding(exports, enablePlugin_1, "enablePlugin");
var loadPlugins_1 = require("./loadPlugins");
__createBinding(exports, loadPlugins_1, "getPluginContext");
__createBinding(exports, loadPlugins_1, "loadPlugins");
__createBinding(exports, loadPlugins_1, "resetPlugins");
var pluginStore_1 = require("./pluginStore");
__createBinding(exports, pluginStore_1, "getPlugin");
__createBinding(exports, pluginStore_1, "getPlugins");
__createBinding(exports, pluginStore_1, "onPluginLoad");
__createBinding(exports, pluginStore_1, "onStateChange");
